import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-detalhes-caixa',
  templateUrl: './detalhes-caixa.component.html',
  styleUrls: ['./detalhes-caixa.component.scss']
})
export class DetalhesCaixaComponent implements OnInit {
  caixa;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef <DetalhesCaixaComponent>,) {
    this.caixa = data.dataDialog;
   }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close("close");
  }

}



// WEBPACK FOOTER //
// /app/src/app/detalhes-caixa/detalhes-caixa.component.ts